<template>
<v-container fluid class="pa-0">
<v-layout row wrap class="ma-0 mt-2" v-if="!loading.fetchData">
    <v-row no-gutters row wrap class="ma-0 mt-0" v-if="quizItemTree.length > 0" >
        <template v-for="(quizTitle, quizTitleIndex) in quizItemTree">
            <v-card v-if="quizTitle.qiz_visibility && quizTitle.children && quizTitle.children.length" :class="'card-with-legend mb-0 mt-2 mb-2'" flat :key="'title-' + quizTitle.qiz_id" color="grey lighten-5">
                <span class="card-legend">{{ quizTitle.qiz_name }}</span>
                <v-row no-gutters row wrap class="ma-0 mt-2" :key="quizTitle.qiz_id + 'row'">
                    <template v-for="(quizItem) in quizTitle.children">
                        <template v-if="quizItem.qiz_visibility">
                            <v-col cols="4" v-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'TITLE'" class="" :key="quizItem.qiz_id">{{ quizItem.qiz_name }}</v-col>
                            <v-col cols="12" v-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'VARCHAR'" class="" :key="quizItem.qiz_id">
                                <v-text-field outlined :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-text-field>
                            </v-col>
                            <v-col cols="12" v-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'TEXT'" class="" :key="quizItem.qiz_id">
                                <v-textarea rows="1" outlined :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-textarea>
                            </v-col>
                            <v-col cols="4" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'INT'" class="quiz-v-card-numeric" :key="'int-' + quizItem.qiz_id">
                                <v-text-field outlined :title="quizItem.qiz_id" :label="quizItem.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" type="number"></v-text-field>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'RADIO'" class="" :key="'radio-' + quizItem.qiz_id">
                                <v-radio-group v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" >
                                    <v-radio v-for="(radio) in quizItem.children" :key="radio.qiz_id" :label="radio.qiz_name" :value="radio.qiz_id">
                                    <template v-slot:label v-if="typeListById[radio.qiz_typ_id_field].typ_name == 'VARCHAR'">
                                        <v-text-field :title="radio.qiz_id" :label="radio.qiz_name" v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"></v-text-field>
                                    </template>
                                    </v-radio>
                                    <!--
                                    -->
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'DATE'" class="pr-2 pl-2" :key="'date-' + quizItem.qiz_id">
                                <DatePicker :label="quizItem.ctp_label" :objectForm="taskItem._pivot['quiz'][quizItem.qiz_id]" fieldName='tqz_txt_value'></DatePicker>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'BOOL'" class="pr-2 pl-2" :key="'bool-' + quizItem.qiz_id">
                                <!-- <p>{{ quizItem.qiz_name }}</p>-->
                                <v-checkbox :title="quizItem.qiz_id" hide-details v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_num_value" :label="quizItem.qiz_name"></v-checkbox>
                            </v-col>
                            <v-col cols="12" v-else-if="typeListById[quizItem.qiz_typ_id_field].typ_name == 'LIST'" class="pr-2 pl-2 pb-2 pt-2" :key="'list-' + quizItem.qiz_id">
                                <!--<v-select v-if="quizItem.qiz_customfields?.list?.length" :title="quizItem.qiz_name" style="z-index: 2000;"
                                    :items="quizItem.qiz_customfields.list"
                                    v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value" :label="quizItem.qiz_name" >
                                </v-select>-->
                                <label :for="'quiz-list-' + quizItem.qiz_id" class="quiz-list-label">{{ quizItem.qiz_name }}</label>
                                <select :id="'quiz-list-' + quizItem.qiz_id" v-if="quizItem.qiz_customfields?.list?.length"
                                    :title="quizItem.qiz_name"
                                    v-model="taskItem._pivot['quiz'][quizItem.qiz_id].tqz_txt_value"
                                    :aria-label="quizItem.qiz_name"
                                    class="native-select-quiz">
                                    <option v-for="(option, idx) in quizItem.qiz_customfields.list" :key="idx" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                            </v-col>
                        </template>
                    </template>
                    <!-- Spécial adds (not from quizz) -->
                    <template v-if="!loading.fetchData & ( quizTitleIndex+1 == quizItemTree.length )">
                        <v-col  cols="12" class="pr-2 pl-2" :key="'add-0'">
                            <v-textarea rows="2" auto-grow outlined label="Remarques générales" v-model="taskItem.tsk_customfields.tsk_remarques"></v-textarea>
                        </v-col>
                        <v-col  cols="12" class="pr-2 pl-2" :key="'add-1'">
                            <AutocompleteMulti 
                                :title="'Taches réalisées'" :ressource="null" 
                                :listObject.sync="taskItem._pivot.tasktypes" :listParent.sync="autoCompleteSource.listTaskTypeItemSource" 
                                :fields="{ 
                                    index: 'tty_id', text:'tty_name,stp_date', autofocus: false, deletablechips: true, hideSelected: false, itemTemplate: true,
                                    search:'tty_name', preprendIcon:'', multiSelect:true, prefetch: true, params: '&extended=withsitetasktype&sit_id=' + taskItem.tsk_sit_id
                            }">
                            <template v-slot:item="{ item }">
                                <!--<v-list-item-avatar><v-icon>mdi-account</v-icon></v-list-item-avatar>-->
                                <v-list-item-content>
                                    <v-list-item-title><v-icon small :color="item.tty_color || 'grey'">mdi-circle</v-icon>{{ item.tty_name }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="(item.stp_date)"><i style="color: green;">{{ (item.stp_date) ? 'Fait le:' : '' }} {{ $date(item.stp_date).format('DD/MM/YYYY') }}</i></v-list-item-subtitle>
                                    <v-list-item-subtitle v-else><i style="color: red;">Jamais</i></v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                            </AutocompleteMulti>
                        </v-col>
                        <v-col  cols="12" class="pr-2 pl-2" :key="'add-2'">
                            <AutocompleteMulti 
                                :title="'Taches à prévoir'" :ressource="null"
                                :listObject.sync="taskActions.tasktypesPrev" :listParent.sync="autoCompleteSource.listTaskTypeItemSource" 
                                :fields="{ 
                                    index: 'tty_id', text:'tty_name', autofocus: false, deletablechips: true, hideSelected: false,
                                    search:'tty_name', preprendIcon:'', multiSelect:true, prefetch: true, params:'' 
                            }"></AutocompleteMulti>
                        </v-col>
                        <template v-for="item in filteredLivestockTypes">
                        <v-col cols="4" class="pr-1 pl-1" :key="'lst-' + item.typ_id">
                            <v-text-field 
                                outlined :title="item.typ_name" :label="item.typ_name" type="number" v-model="livestockCounts[item.typ_id]" @change="taskActions.createAssign = true"
                                :hint="(taskItem.tsk_customfields.tsk_livestockdiff && taskItem.tsk_customfields.tsk_livestockdiff[item.typ_id]) ? taskItem.tsk_customfields.tsk_livestockdiff[item.typ_id] + '' : ''" persistent-hint>
                            </v-text-field>
                        </v-col>
                        </template>
                        <v-col cols="6">
                            <span>Bon de transhumance</span>
                            <v-switch v-model="taskActions.createAssign" class="mt-0" title="Bon de transhumance" hide-details color="primary" input-value="true"></v-switch>
                        </v-col>
                        <v-col cols="6">
                        <AutocompleteMulti 
                                :title="'Mort(s)'" 
                                :listObject.sync="taskActions.deadLivestock" :listParent.sync="siteItem.livestocks" 
                                :fields="{ 
                                    index: 'lst_id', text:'lst_name', autofocus: false, deletablechips: true,
                                    search:'lst_name', preprendIcon:'', multiSelect:true, prefetch: false, params:'' 
                            }"></AutocompleteMulti>
                        </v-col>
                    </template>
                                       
                </v-row>
            </v-card>
            <!-- &nbsp;<v-divider v-if="quizTitleIndex && quizTitle.qiz_visibility && quizTitle.children && quizTitle.children.length" :key="'divider-' + quizTitleIndex" class="mt-2 mb-5 my-4"></v-divider> -->
        </template>
    </v-row>
</v-layout>
</v-container>
</template>


<script>
import DatePicker from '@/components/ui/DatePicker'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

import { mapState, mapWritableState, mapActions } from 'pinia'
import { useQuizStore } from '@/stores/quiz'
import { useTypeStore } from '@/stores/type'
import { useTaskStore } from '@/stores/task'
import { useSiteStore } from '@/stores/site'

export default {
    name: 'task-quiz-edit',
    props: [ 'quiz', 'task' ],
    components: {
        DatePicker, AutocompleteMulti
    },
    computed: {
        ...mapState(useQuizStore, {quizItemList: 'itemList', quizItemTree: 'itemTree' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapWritableState(useTaskStore, { taskItem: 'item', taskActions: 'actions' }),
        ...mapState(useSiteStore,         { siteItem: 'item' }),
        validQuizCount() {
            return this.quizItemTree.filter(item => item.qiz_visibility && item.children && item.children.length > 0).length
        },
        filteredLivestockTypes() {
            return (this.typeListByGroup['LST'] || []).filter(item => item.typ_visibility !== 0);
        },
        livestockDiffs() {
            const diffs = {};
            for (const typId in this.livestockCounts) {
            const initial = this.initialLivestockCounts[typId] || 0;
            const current = Number(this.livestockCounts[typId]) || 0;
                if (current !== initial) {
                    diffs[typId] = current - initial;
                }
            }
            return diffs;
        }
    },
    data: function () {
        return {
            loading : { fetchData: true },         // Enregistrement en cours...
            typPanel: 0,
            radioGroup: null,
            formValues: {},
            autoCompleteSource: { listTaskTypeItemSource: [], livestockDead: [] },
            livestockCounts: {}, // current values (bound to fields)
            initialLivestockCounts: {}, // original counts from siteItem
        }
    },
    async mounted (){
        let params = '' //(this.task.tsk_id) ? '&tqz_tsk_id=' + this.task.tsk_id : ''
        await this.quizFetchItems('?per_page=false&qiz_typ_id=QIZ01' + params)
        this.quizItemList.forEach(elem => {
            if( !this.taskItem._pivot['quiz'][elem.qiz_id] ){
                this.taskItem._pivot['quiz'][elem.qiz_id] = { tqz_tsk_id: this.task.tsk_id, tqz_qiz_id: elem.qiz_id, tqz_num_value: 0, tqz_txt_value: null }
            }
          //this.formValues[elem.qiz_id] = { tqz_tsk_id: this.task.tsk_id, tqz_qiz_id: elem.qiz_id, tqz_num_value: null, tqz_txt_value: null }
        })
        if (this.siteItem && Array.isArray(this.siteItem.livestocks)) {
            const counts = {}
            this.siteItem.livestocks.forEach(lst => {
                const typId = lst.lst_typ_id
                counts[typId] = (counts[typId] || 0) + 1
            })
            this.initialLivestockCounts = { ...counts }
            this.livestockCounts = { ...counts }
        }
        this.$http.get('/tasktypes/?per_page=false&=&extended=withsitetasktype&sit_id=' + this.taskItem.tsk_sit_id).then( (response) => {
            this.autoCompleteSource.listTaskTypeItemSource = response.data.data
            this.loading.fetchData = false
        })

    },
    methods: {
        ...mapActions(useQuizStore, { quizFetchItems: 'fetchItems'}),
        getLivestockDiffs() {
            return { ...this.livestockDiffs }
        }
    }
}
</script>

<style>
.quiz-v-card > div {
  border: solid 1px #2daee5 !important;
  border-radius: 24px !important;
  padding: 4px !important;
  margin-bottom: 8px !important;
}

.quiz-v-card-numeric > div {
    padding: 2px !important;
}

.quiz-legend {
  display: block;
  padding: 0 2px 0 6px;
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 1.1em;
  color: #333;
}

.card-with-legend {
  position: relative;
  border: 1px solid #3d946d !important;
  border-radius: 8px !important;
}

.card-legend {
  position: absolute;
  top: -12px;
  left: 20px;
  background: white;
  padding: 0 8px;
  color: #3d946d;
  font-weight: bold;
  font-size: 14px;
}

.v-carousel__controls{
    background: #006685 !important;
    height: 28px;
    position: relative;
}

.native-select-quiz {
    width: 100%;
    padding: 8px 12px;
    font-size: 16px; /* Évite le zoom auto sur iOS */
    border: 1px solid rgba(0, 0, 0, 0.38);
    border-radius: 8px;
    background-color: #fff;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23006685'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 20px;
    padding-right: 32px;
}

.native-select-quiz:focus {
    outline: none;
    border-color: #006685;
    border-width: 2px;
}
.quiz-list-label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
}

.native-select-quiz:focus {
    outline: none;
    border-color: #006685;
    border-width: 2px;
}
</style>